'use client';
import { CookiesProvider as BaseCookiesProvider, Cookies } from 'react-cookie';

import { useRemoveCookie, useSetCookie } from '@/hooks/use-cookies';
import { Cookie } from '@/types/storage';
import type { DeviceType } from '@/types/types';
import { useLocale } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { type ReactNode, useEffect } from 'react';

interface Props {
  children: ReactNode;
  cookieHeader: string | null;
  deviceType: DeviceType;
}

const CookiesProvider = ({ children, cookieHeader, deviceType }: Props) => {
  const locale = useLocale();
  const setCookie = useSetCookie();
  const removeCookie = useRemoveCookie();
  const searchParams = useSearchParams();
  const clearToken = searchParams.get('clearToken');

  useEffect(() => {
    setCookie(Cookie.DEVICE_TYPE, deviceType);
  }, []);

  useEffect(() => {
    if (clearToken) {
      removeCookie(Cookie.LOGIN_SECRET);
      removeCookie(Cookie.CUSTOMER_EMAIL);
      removeCookie(Cookie.JUST_LOGGED_IN);
    }
  }, [clearToken]);

  useEffect(() => {
    if (locale && process.env.NEXT_PUBLIC_LANGUAGE) {
      setCookie(Cookie.NEXT_LOCALE, locale);
    }
  }, [locale]);

  return (
    <BaseCookiesProvider cookies={new Cookies(cookieHeader)}>
      {children}
    </BaseCookiesProvider>
  );
};

export default CookiesProvider;
